export const msalConfig = {
    auth: {
        clientId: '4b11ccce-6336-4df1-b5ab-59b848a564c9',
        authority:
            'https://login.microsoftonline.com/87a77ca5-9e11-4e7f-932a-57ec1a06bc78', // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: 'https://apcm.ioagpl.com',
    },
    cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [`4b11ccce-6336-4df1-b5ab-59b848a564c9/.default`]
};